import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

import { colors } from 'core/styles';

// tslint:disable:max-line-length
function DecreaseIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        d="M13.4139 8.75735V14.4142M7.75705 14.4142L13.4139 14.4142M13.4139 14.4142L5.4997 6.5"
        stroke={colors.scarlet[100]}
      />
    </SvgIcon>
  );
}

export { DecreaseIcon };
